<template>
	<div class="backTop" v-on:click="toTop"><i class="el-icon-top"></i></div>
</template>

<script>
import $ from 'jquery'
export default {
	name: "BackTop",
	methods: {
		toTop(){
			$('html,body').animate({scrollTop:0},800);
		}
	}
}
</script>

<style scoped>
	.backTop{
		position: fixed;
		right: 15px;
		bottom: 15px;
		z-index: 9999;
		width: 24px;
		height: 24px;
		background: rgba(66, 80, 102, 0.7);
		color: #ffffff;
		text-align: center;
		padding: 3px 3px;
	}
	.backTop i{
		font-size: 24px;
	}
</style>